export default {
  logout: "Log out",
  requests: "Requests",
  offers: "Offers",
  stages: "Stages",
  client: "Client",
  accommodation: "Accommodation",
  accommodation_other: "Accommodations",
  bike_rental: "Bike rental",
  activity: "Activity",
  activity_other: "Activities",
  transport: "Transport",
  stage: {
    duration: "Duration",
    distance: "Distance",
    stage: "Stage",
    name: "Name",
    url: "URL",
    code: "Code",
    start: "Start",
    end: "End",
    location_from: "Start location",
    location_to: "End location",
    english_description: "English description",
    german_description: "German description",
    modified: "Modified",
    modified_by: "Modified by",
    create_new: "Create new",
    img: "Upload an image",
    cancel: "Cancel",
    create: "Create",
    save: "Save",
    image_remove: "This image will be removed",
    leave: "Leave",
    leave_page_question: "Changes that you made may not be saved. Do you want to leave the page?",

    toast: {
      fetch_failed: "Failed to fetch data",
      fetch_failed_code: "Failed to fetch data ({{code, string}})",
      fetch_failed_status: "Failed to fetch data ({{status, string}})",
      edit_failed: "Failed to edit",
      edit_failed_code: "Failed to edit ({{code, string}})",
      edit_failed_status: "Failed to edit ({{status, string}})",
      edit_success: "Successfully edited",
      create_failed: "Failed to create",
      create_failed_code: "Failed to create ({{code, string}})",
      create_failed_status: "Failed to create ({{status, string}})",
      create_success: "Successfully created",
      success: "Success",
      error: "Error",
      submit_failed: "Failed to submit form. Please try again.",
      submit_failed_status: "Failed to submit form ({{status, string}})",
      submit_success: "Failed to submit form. Please try again.",
      success_create_stage: "Successfully added a new stage",
      success_edit_stage: "Successfully updated stage",

    },
  },

  trail_management: "Trail management",
  status: 'Status',
  first_name: "First name",
  last_name: "Last name",
  mobile_number: "Mobile number",
  email: "E-mail",
  date_of_birth: "Date of birth",
  main_guest: "I'm the main guest",
  not_main_guest: "I'm booking for someone else",

  request: {
    status: {
      new: "New",
      processed: "Processed",
      deleted: "Deleted"
    },

    trail_service: {
      luggage_transport: 'Luggage transport',
      guide: 'Guide',
      back_transfer: 'Back transfer',
      mobility_service: 'Mobility service'
    },

    list_of_requests: 'List of requests',

    guest: {
      age:"Age",
      guests: "Guests",
      name: 'First name',
      surname: 'Last name',
      stages: "Stages",
      mobile_number: 'Mobile number',
      email: 'E-mail',
      number_of_adults: "Number of adults",
      number_of_children: "Number of children",
    },

    toast: {
      fetch_failed: "Failed to fetch data",
      fetch_failed_code: "Failed to fetch data ({{code, string}})",
      fetch_failed_status: "Failed to fetch data ({{status, string}})",
      edit_failed: "Failed to edit",
      edit_failed_code: "Failed to edit ({{code, string}})",
      edit_failed_status: "Failed to edit ({{status, string}})",
      edit_success: "Successfully edited",
      create_failed: "Failed to create",
      create_failed_code: "Failed to create ({{code, string}})",
      create_failed_status: "Failed to create ({{status, string}})",
      create_success: "Successfully created",
      success: "Success",
      error: "Error",
      submit_failed: "Failed to submit form. Please try again.",
      submit_failed_status: "Failed to submit form ({{status, string}})",
      submit_success: "Failed to submit form. Please try again.",
      success_add_stage: "Successfully added a new stage",
      success_edit_stage: "Successfully updated stage",

    },

    create_new: 'Create new',
    create: 'Create',
    cancel: 'Cancel',
    date_created: 'Created',
    date_created_from: 'Created from',
    date_created_to: 'Created to',
    start_date: 'Start date',
    start_date_from: 'Start date from',
    start_date_to: 'Start date to',
    end_date: 'End date',
    end_date_from: 'End date from',
    end_date_to: 'End date to',
    trail: 'Trail',
    stage: 'Stage',
    date_processed: 'Processed on',
    processed_by: 'Processed by',
    request_data: 'Request data',
    request: "Request",
    create_request: 'Create a request',
    request_details: 'Request details',
    created: 'Created',
    note_from_client: 'Note from client',
    delete_request: 'Delete request',
    process_request: 'Process request',
    undo_deletion: 'Undo deletion',
    adults: 'Adults',
    children: 'Children',
    deal: 'Deal',
    number_of_adults: 'Number of adults',
    number_of_children: 'Number of children',
    number_of_rooms: 'Number of rooms',
    guide: 'Guide',
    mobility_service: 'Mobility service',
    back_transfer: 'Back transfer',
    luggage_transfer: 'Luggage transfer',
    rooms: 'Rooms',
    basic: 'Basic',
    classic: 'Classic',
    comfort: 'Comfort',
    no_board: 'No board',
    bed_and_breakfast: 'Bed and breakfast',
    half_board: 'Half board',
    board: 'Board',
    accommodation_category: 'Accommodation category',
  },

  offer: {
    price: "Price",
    confirmed_price: "Confirmed price",
    date_created: 'Created',
    date_created_from: 'Created from',
    date_created_to: 'Created to',
    start_date: 'Start date',
    start_date_from: 'Start date from',
    start_date_to: 'Start date to',
    end_date: 'End date',
    end_date_from: 'End date from',
    end_date_to: 'End date to',
    modified: "Modified",
    modified_by: "Modified by",
    leave_page_question: "Changes that you made may not be saved. Do you want to leave the page?",
    leave: "Leave",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    days: "Days",
    days_in_request: "Days in the request",
    days_in_offer: "Days in this offer",
    offer_details: "Offer details",
    reject_offer: "Reject offer",
    send_off: "Sent to client",
    book_with_the_provider: "Book all with service providers",
    booking_confirmed: "Booking confirmed",
    download_travel_document_en: "Download travel document - ENG",
    download_travel_document_de: "Download travel document - DE",
    download_offer_document_de: "Download offer document - DE",
    download_offer_document_en: "Download offer document - ENG",
    created: 'Created',
    tour_plan: 'Tour plan',
    cost_breakdown: 'Cost breakdown',
    add_service: "Add service",
    booking_confirmed_warning: "All services need to be confirmed before the booking of the offer can be confirmed.",
    add_day_warning: "Cannot add a day here, as it would affect an already booked reservation",
    delete_day_warning: "Cannot delete this day, as it would affect an already booked reservation",
    select_service: "Service",
    service_type: "Service type",
    guests: "Guests",
    reservation_details: "Reservation details",
    reservation_status: "Reservation status",
    stage: "Stage",
    bikes: "Bikes",
    number_of_bikes: "Number of bikes",
    check_out_date: "Check out date",
    number_of_nights: "Number of nights",
    pickup_time: "Pickup time",
    return_time: "Return time",
    return_date: "Return date",
    from_location: "From location",
    to_location: "To location",
    time: "Time",
    trail_service: "Trail Service",
    calculated_trail_service: "Suggested trail service price:",
    amount_paid: "Amount paid",
    amount_paid_by_guest: "Amount paid by guest",
    left_to_pay: "Left to pay",
    distance: "Distance",
    transport_price_formula: "Price per KM * (Number of persons + Number of bikes) * Distance ",
    accommodation_price_formula: "Number of days * Price per day",
    activity_price_formula: "Price per person * Number of persons",
    bike_rental_price_formula: "Number of days * Price per day * Quantity",
    delete_day_question: "Are you sure you want to delete this day?",
    delete_service_question: "Are you sure you want to delete this service from the tour plan? The reservation will be cancelled if it was already sent to the service providers.",
    delete: "Delete",
    total: "Total",
    warning: "Warning",

    status: {
      status: 'Status',
      open: "Open",
      sent: "Sent",
      pending: "Pending",
      rejected: "Rejected",
      booking_pending: "Booking pending",
      booked: "Booked",
      not_booked: "Not booked",
      new: "New",
      cancelled_before_booked: "Cancelled before booked",
      cancelled_unseen: "Cancelled unseen",
      sent_to_service_provider: "Sent to service provider",
      in_progress: "In progress",
      confirmed: "Confirmed",
      cancelled: "Cancelled",
    },

    guest: {
      age: 'Age',
      name: 'First name',
      surname: 'Last name',
      guests: "Guests",
      stages: "Stages",
      mobile_number: 'Mobile number',
      email: 'E-mail',
      number_of_adults: "Number of adults",
      number_of_children: "Number of children",
    },

    service: {
      select_bike_rental: "Select bike rental service",
      select_accommodation: "Select accommodation service",
      select_transport: "Select transport service",
      select_activity: "Select activity service",
      name: "Name",
      service_provider: "Service provider",
      location: "Location",
      quantityAvailable: "Quantity available",
      quantityAvailable_from: "Quantity available from",
      quantityAvailable_to: "Quantity available to",
      passengerCapacity: "Passenger capacity",
      passengerCapacity_from: "Passenger capacity from",
      passengerCapacity_to: "Passenger capacity to",
      bikeCapacity: "Bike capacity",
      bikeCapacity_from: "Bike capacity from",
      bikeCapacity_to: "Bike capacity to",
      bike_type: "Bike type",
      pricePerKM: "Price per KM",
      additionalInformation: "Additional information",
      numberOfGuests: "Number of guests",
      numberOfGuests_from: "Number of guests from",
      numberOfGuests_to: "Number of guests to",
      numberOfStars: "Number of stars",
      numberOfStars_from: "Number of stars from",
      numberOfStars_to: "Number of stars to",
      propertyType: "Property type",
      price: "Price",
      size: "Size",
      type: "Type",
      pricePerDay: "Price per day",
      openingTime: "Opening time",
      closingTime: "Closing time",
      category: "Category",
      duration: "Duration",
      quantity_available: "Quantity available",
      remove_service: "Remove this service",
      opens: "Opens",
      closes: "Closes",
      time_during_work_hours: "Time must be during work hours",
    }
  },

  user_profile: {
    user_info: "User Info",
    change_password: "Change password"
  },

  my_profile: "My profile",

  user: {
    first_name: "First name",
    last_name: "Last name"
  },

  toast: {
    fetch_failed: "Failed to fetch data",
    fetch_failed_code: "Failed to fetch data ({{code, string}})",
    fetch_failed_status: "Failed to fetch data ({{status, string}})",
    edit_failed: "Failed to edit",
    edit_failed_code: "Failed to edit ({{code, string}})",
    edit_failed_status: "Failed to edit ({{status, string}})",
    edit_success: "Successfully edited",
    create_failed: "Failed to create",
    create_failed_code: "Failed to create ({{code, string}})",
    create_failed_status: "Failed to create ({{status, string}})",
    create_success: "Successfully created",
    success: "Success",
    reject_success:"Offer is successfully rejected",
    reject_error:"It is not possible to reject offer if offer status is not SENT",
    send_success:"Offer is successfully sent",
    send_error:"It is not possible to send offer if offer status is not OPEN",
    book_with_provider_success:"Offer is successfully booked with service provider",
    book_with_provide_error:"It is not possible to book offer with service provider if offer status is not SENT",
    booking_success:"Offer booking is successfully confirmed",
    booking_error:"It is not possible to confirm offer booking if offer status is not BOOKING PENDING",
    error: "Error",
    submit_failed: "Failed to submit form. Please try again.",
    submit_failed_status: "Failed to submit form ({{status, string}})",
    submit_success: "Failed to submit form. Please try again.",
    fill_outlined_fields: "Please ensure that all outlined fields are filled correctly.",
    info: "Info",
  },

  create: "Create",
  footprint: {
    ecological_footprint: "Ecological footprint",
    carbon_footprint: "Carbon footprint",
    water_consumption: "Water consumption",
    waste_generation: "Waste generation",
  },

  create_new: "Create",
  save: "Save",
  remove_filters: "Remove all filters",
  length_exceeded_error: "Length exceeded",
  field_format_error: "Field can’t be blank",
  first_name_format_error: "First name can’t be blank",
  last_name_format_error: "Last name can’t be blank",
  required_field: "This is a required field",
  email_not_valid: "E-mail is not valid",
  date_from_today: "Date must be from today or greater",
  greater_than_zero:"Number must be grater than 0",
  greater_or_equal_to_zero:"Number must be greater or equal to 0",
  less_than_sixty:"Number must be less than 60",
  number_between_min_max: "Number must be between {{min}} and {{max}}",
  return_date_after_start_date: "Return date must be after start date",
  leave_page:"Leave page",
  must_be_number: "Value must be a number",
  selected_service_allows_up_to_guests: "Selected service allows up to {{maxNumberOfGuests, string}} guests",
  selected_service_allows_up_to_bikes: "Selected service allows up to {{maxNumberOfBikes, string}} bikes",
  return_date_after_day_date: "Return date must be after the current day",
  date_after_today_date: "Date must be after today's date",
  date_before_today: "Date must be before today's date",
  warning: "Warning",
  edit: "Edit",
  start_typing_to_search: "Start typing to search",
  leave_page_title: "Warning",
  leave_page_question: "Changes that you made may not be saved. Do you want to leave the page?",
  leave: "Leave",
  reason_for_rejection: "Reason for rejection",
  click_rejection_reason: "Click for rejection reason",
  cancel: "Cancel",
  message_service_provider: "Message from service provider",

  activity_categories: {
    river_journey: "River journey",
    wine_tasting: "Wine tasting",
    gastronomy: "Gastronomy",
    amazing_moment: "Amazing moment",
    other: "Other",
  },
  bike_type: {
    road_bike: "Road bike",
    mountain_bike: "Mountain bike",
    electric_bike: "Electric bike",
    hybrid_bike: "Hybrid bike",
    gravel_road_bike: "Gravel road bike",
    folding_bike: "Folding bike",
    touring_bike: "Touring bike",
    other: "Other",
  },
};
